// api/axiosConfig.js
import axios from "axios";

const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const tenantId = sessionStorage.getItem("tenantId");

    if (
      !config.url?.includes("/api/smtp-provider") &&
      !config.url?.includes("/api/getUserCompanies") &&
      !config.url?.includes("/api/create-tenant") &&
      !config.url?.includes("/api/companies/self-service") &&
      !config.url?.includes("/api/companies/check-slug") &&
      !config.url?.includes("/api/debtor-creditor-file/parse") &&
      !config.url?.includes("/api/counterparties/parse") &&
      !config.url?.includes("/api/counterparties/import") &&
      !config.url?.includes("/api/generate-company-description") &&
      !config.url?.includes("/api/cost-center-file/parse") &&
      !config.url?.includes("/api/accounts-file/parse") &&
      !config.url?.includes("/open-ai/session") &&
      !config.url?.includes("/api/reauthenticate-bank-connection") &&
      !config.url?.includes("/api/add-bank-account") &&
      !config.url?.includes("/api/sync-bank-accounts-and-import") &&
      !tenantId
    ) {
      console.log(`Axios error: tenantID not available ${config.url}`);
      return Promise.reject("tenantId not available");
    }

    config.headers["X-Tenant-ID"] = tenantId;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;
